<template>
  <div>
    <div id="edit" v-if="state === 'edit'">
      <ElButton @click="state = 'index'" icon="el-icon-back">
        Back
      </ElButton>
      <h3>Edit collection</h3>
      <ElRow>
        <ElCol :span="6">
          <ElUpload
            class="avatar-uploader"
            list-type="picture-card"
            :action="'/api/upload?' + current"
            :headers="thumbHeaders"
            :on-success="thumbUploadDone"
            :show-file-list="false"
          >
            <img v-if="record.thumb" :src="record.thumb" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
            >
          </ElUpload>

          <br /><br /><ElButton
            @click.stop="deleteThumb(record.uuid)"
            v-if="record.thumb"
          >
            Delete cover
          </ElButton>
        </ElCol>

        <ElCol :span="18">
          <label>
            Name
            <input
              type="text"
              @input="isChanged = true"
              v-model="record.name"
            />
          </label>
          <label> Slug <input type="text" v-model="record.slug" /> </label>
          <label>
            Subtitle <textarea type="text" v-model="record.subtitle" />
          </label>
          <label>
            Description
            <textarea rows="10" type="text" v-model="record.description" />
          </label>
          <label>
            Acknowledgements
            <textarea rows="10" type="text" v-model="record.acknowledgements" />
          </label>
          <label>
            Status<select v-model="record.status">
              <option>editor</option>
              <option>uploaded</option>
              <option>public</option>
            </select>
          </label>

          <label>
            Partner
            <SelectPartner
              :value="record.partner"
              v-model="record.partner"
              :options="$store.getters['admin/forms']['partners']"
              @remove="partnerRemove(record)"
            />
          </label>
        </ElCol>
      </ElRow>

      <ElRow>
        <ElCol :span="18">
          <ElButton
            :disabled="!isChanged"
            style="align:center"
            type="primary"
            @click="saveData"
          >
            Save
          </ElButton>
        </ElCol>
      </ElRow>

      <br />

      <table class="datatable" cellpadding="10" cellspacing="10">
        <tr :key="offset" v-for="(i, offset) in record.items">
          <td width="20%">
            <img :src="i.url" />
          </td>
          <td>
            <label> Title <input type="text" v-model="i.title" /> </label>
            <label>
              Description
              <textarea rows="8" type="text" v-model="i.description" />
            </label>

            <label>
              Copyright
              <SelectCopyright
                @remove="copyRemove(i)"
                @input="copyChanged(i)"
                :options="copyrightOptions"
                v-model="i.copyright"
              />
            </label>

            <label>
              Partner
              <SelectPartner
                @remove="partnerRemove(i)"
                @input="partnerChanged(i)"
                :options="$store.getters['admin/forms']['partners']"
                v-model="i.partner"
              />
            </label>

            <ElButton type="danger" @click="itemDelete(offset)">
              Delete
            </ElButton>
            <ElButton
              type="primary"
              circle
              icon="el-icon-arrow-up"
              @click="itemUp(offset)"
            />
            <ElButton
              type="primary"
              circle
              icon="el-icon-arrow-down"
              @click="itemDown(offset)"
            />
          </td>
        </tr>
      </table>

      <ElButton type="primary" @click="saveData">
        Save
      </ElButton>
    </div>

    <div id="index" v-if="state === 'index'">
      <ElUpload
        style="float:right"
        :file-list="fileList"
        :headers="headers"
        :on-error="uploadError"
        :on-success="uploadOk"
        :show-file-list="false"
        class="upload-pptx"
        action="/api/upload"
      >
        <input
          type="hidden"
          name="session"
          :value="$store.getters['user/session']"
        />
        <ElButton size="small" type="primary">
          <i class="el-icon-upload" /> Click to upload
        </ElButton>
        <div slot="tip" class="el-upload__tip">
          Only upload Powerpoint<br /><u>PPTX</u> files here
        </div>
      </ElUpload>

      <h1>Collections</h1>
      <table class="dataTable">
        <thead>
          <tr>
            <th>Created</th>
            <th>Name</th>
            <th>Subtitle</th>
            <th>Status</th>
            <th>License</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr :key="k" v-for="(c, k) in collections" @click="cEdit(c.uuid)">
            <td width="120">
              {{ (c.ts / 1000) | moment("from") }}
            </td>
            <td width="300">
              {{ c.name }}
            </td>
            <td width="300">
              {{ c.subtitle }}
            </td>
            <td>{{ c.status }}</td>
            <td width="200">
              {{ c.license ? c.license : "&mdash;" }}
            </td>
            <td align="right" valign="bottom">
              <ElButtonGroup style="margin: 20px 0">
                <a
                  target="_new"
                  :href="getLink(c)"
                  @click.stop="state = 'index'"
                >
                  <ElButton
                    title="View"
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                  />
                </a>
                <ElButton
                  @click.stop="cEdit(c.uuid)"
                  title="Edit"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                />
                <ElButton
                  @click.stop="cDelete(c.uuid)"
                  title="Delete"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                />
              </ElButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>

      <ElDialog title="Tips" :visible.sync="dialogVisible" width="30%">
        <span>This is a message</span>
        <span slot="footer" class="dialog-footer">
          <ElButton @click="dialogVisible = false" icon="el-icon-error">
            Cancel
          </ElButton>
          <ElButton
            type="primary"
            @click="dialogVisible = false"
            icon="el-icon-success"
          >
            Confirm
          </ElButton>
        </span>
      </ElDialog>
    </div>
  </div>
</template>

<script>
import SelectCopyright from "@/components/selectCopyright"
import SelectPartner from "@/components/selectPartner"

export default {
  name: "Importcollection",
  components: {
    SelectCopyright,
    SelectPartner
  },

  watch: {
    // TODO: FIX
    // we really only want to see user input triggered changes
    // but loading data also triggers this, effectively having "Save"
    // enabled most of the time, regardless user state.
    record: {
      handler(val, oldVal, e) {
        console.log("record change handler with: ", val, oldVal, e)
        this.isChanged = true
      },
      deep: true
    }
  },

  methods: {
    partnerRemove(item) {
      console.log("remove: ", item)
      this.$API.post("/collection/removePartner", {
        item: item.uuid,
        partner: item.partner
      })
    },

    partnerChanged(e) {
      console.log("change partner: ", e)
      this.$API.post("/collection/changePartner", {
        item: e.uuid,
        partner: e.partner
      })
    },

    copyRemove(item) {
      this.$API.post("/collection/removeCopyright", {
        item: item.uuid,
        copyright: item.copyright
      })
    },

    copyChanged(e) {
      this.$API.post("/collection/changeCopyright", {
        item: e.uuid,
        copyright: e.copyright
      })
    },

    thumbUploadDone(e, x) {
      console.log("upload done", e)
      console.log(">> ", x)
      this.record.thumb = e.url
    },

    itemUp(i) {
      let item = this.record.items[i]
      this.record.items.splice(i, 1)
      this.record.items.splice(i - 1, 0, item)
      for (i = 0; i < this.record.items.length; i++) {
        this.record.items[i].order = i + 1
      }
    },

    itemDown(i) {
      let item = this.record.items[i]
      this.record.items.splice(i, 1)
      this.record.items.splice(i + 1, 0, item)
      // fix order
      for (i = 0; i < this.record.items.length; i++) {
        this.record.items[i].order = i + 1
      }
    },

    itemDelete(i) {
      let item = this.record.items[i]
      this.record.items.splice(i, 1)
      // let api know
      this.$API.post("/collection/deleteItem", {
        collection: this.record.uuid,
        item: item.uuid
      })
    },

    saveData() {
      //console.log("save data")
      this.$API.post("/collection/edit/" + this.current, this.record).then(r => {
        console.log("saveData resp: ", r)
        this.state = "index"
        this.$notify.info({ title: "Saved" })
        this.loadData()
      })
    },

    loadData() {
      this.$API.get("/admin/collections")
        .then(r => {
          this.collections = r.data
          this.isChanged = false
        })
        .catch(e => {
          this.$notify.error({
            title: "API error",
            message: e.response.data
          })
        })
    },

    getLink(c) {
      // fix content-link from admin.dev.historiana.eu to dev.historinia.eu 
      let me = document.location.origin.toString().replace("admin.", "")
      return `${me}/historical-content/source-collections/${c.slug}`
    },

    cEdit(e) {
      // this.dialogVisible = true
      this.state = "edit"
      this.current = e

      this.$API.get("/collection/edit/" + e).then(r => {
        console.log("loaded collection ", e)
        this.record = r.data.data
        this.isChanged = false
      })

      this.isChanged = false
    },

    deleteThumb(e) {
      this.$confirm("This will delete the cover image. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          // TODO: sent session or user to validate on server side if delete is permitted
          this.$API.delete("/admin/collectionThumb/", {
            data: { collection: e, user: "user" }
          })
          //this.collections = r.data
          this.loadData()
          this.record.thumb = null
          this.$message({
            type: "success",
            message: "Delete completed"
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          })
        })
    },

    cDelete(e) {
      this.$confirm(
        "This will permanently delete the collection. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          // TODO: sent session or user to validate on server side if delete is permitted
          this.$API.delete("/admin/collection/", {
            data: { collection: e, user: "user" }
          })
          //this.collections = r.data
          this.loadData()
          this.$message({
            type: "success",
            message: "Delete completed"
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          })
        })
    },

    uploadOk(e, f) {
      // this.$store.dispatch('user/getSources')

      console.log("added: ", f)

      this.$notify.success({
        title: `Upload OK`,
        message: `${f.name} added.`
      })

      this.loadData()
    },

    uploadError(e, x, y) {
      // XXX find out how we can access our JSON errorCode
      // to report exact error
      console.log("ERROR UPLOAD", e, typeof e)
      console.log("x: ", x)
      console.log("y: ", y)
      this.$notify.error({
        title: "Error uploading file",
        message: ""
      })
    }
  },

  mounted() {
    console.log("** MOUNT Collections.vue")
    this.$API.get("/select/copyright").then(r => {
      this.copyrightOptions = r.data
    }).catch(e => {
      console.log("GET COPY err ", e)
    })
    this.loadData()
  },

  data() {
    return {
      isChanged: false,
      copyrightOptions: [],
      state: "index",
      current: null,
      record: {},
      dialogVisible: false,
      collections: [],
      fileList: [],
      headers: {
        // these are needed in the API to identify the user
        "X-Session": this.$store.getters["user/session"],
        "X-Process": "createCollectionfromPPTX"
      },
      thumbHeaders: {
        // these are needed in the API to identify the user
        "X-Session": this.$store.getters["user/session"],
        "X-Process": "thumbForCollection",
        "X-Collection": "xxx"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../Style.scss";

table {
  border-collapse: separate;
}

.datatable tr:nth-child(odd) {
  background-color: #ccc;
}

.datatable td {
  padding: 1em;
}

.datatable tr {
  border-bottom: 2px solid green;
  padding-bottom: 3em !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
